import { DatePicker } from "@fluentui/react";
import { calenderFix } from "../../styles/customStyles";

export const DatepickerComponent = (props: any) => { 
    return <DatePicker 
            {...props} 
            placeholder="Select a date..." 
            maxDate={props.maxDate != undefined && props.maxDate === true ? new Date() : null} onSelectDate={(e: any) => props.setDropDownValue2(e)} 
            value={props.dropDownValue2}
    />; 
};

// export const DatepickerComponent = ({ maxDate, setDropDownValue2 }) => {
//     return <DatePicker
//         placeholder="Select a date..."
//         maxDate={maxDate != undefined && maxDate === true ? new Date() : null} onSelectDate={(e: any) => setDropDownValue2(e)}
//         style={calenderFix}
//     />;
// };